import { cn } from '@/lib/utils';

export interface RowTotalCellProps {
  /** Sum of the row's hours across the visible days. */
  total: number;
}

/** Total hours cell for a single timesheet row. */
export function RowTotalCell({ total }: RowTotalCellProps) {
  return (
    <td className={cn(
      "p-1 sm:p-1.5 text-center font-bold text-sm",
      total > 0 ? "text-foreground bg-muted/30" : "text-muted-foreground/50"
    )}>
      {total.toFixed(2)}
    </td>
  );
}
